import { format } from 'date-fns';
import { AvailableAppLocales } from '../availableAppLocales';

export const formatDate = (dateString, dateFormat, locale) => {
  return format(new Date(dateString), dateFormat, {
    locale: AvailableAppLocales?.[locale],
  });
};
/**
 * getMonthTitleFromMonthNumber
 * @description get month text from month number
 * */
export const getMonthTitleFromMonthNumber = (monthNumber) => {
  const date = new Date();
  date.setMonth(monthNumber);
  return date.toLocaleString('en-US', { month: 'long' });
};
